// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file api/v1/api.proto (package api.v1, syntax proto3)
/* eslint-disable */

import { BackendService } from "./api_pb";

/**
 * @generated from rpc api.v1.BackendService.ListCacheEntries
 */
export const listCacheEntries = BackendService.method.listCacheEntries;

/**
 * @generated from rpc api.v1.BackendService.DeleteCacheEntries
 */
export const deleteCacheEntries = BackendService.method.deleteCacheEntries;

/**
 * @generated from rpc api.v1.BackendService.Insights
 */
export const insights = BackendService.method.insights;
